import { SortDirection } from "@redotech/redo-model/tables/table";
import {
  ReviewRating,
  ReviewStatus,
} from "@redotech/redo-review-db-schema/review";
import { reviewBodySchema } from "@redotech/redo-review-db-schema/review-body-schema";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const sortSchema = z.object({
  direction: createEnum(SortDirection),
  key: z.string(),
});

export const getReviews = {
  name: "getReviews" as const,
  input: z.object({
    teamId: z.string(),
    statuses: z.optional(z.array(createEnum(ReviewStatus))),
    ratings: z.optional(z.array(createEnum(ReviewRating))),
    verifiedPurchase: z.optional(z.boolean()),
    shopifyProductId: z.optional(z.string()),
    sort: z.optional(sortSchema),
    search: z.optional(z.string()),
    page: z.optional(z.number().positive().int()),
    pageSize: z.optional(z.number().positive().int()),
  }),
  output: z.object({
    reviews: z.array(reviewBodySchema),
    totalCount: z.number().int(),
  }),
};
